import React from "react";
import styled from "styled-components";
import getConfig from "next/config";
import { Form } from "react-bootstrap";

import { hexToRGBA } from "../../../utils/theme";

const { publicRuntimeConfig } = getConfig();

const StyledGroup = styled(Form.Group)`
  padding-left: 0;
  padding-right: 0;
  
  input:checked,
  input:not(:checked) {
    position: absolute;
    left: -9999px;
  }

  input:checked + label,
  input:not(:checked) + label {
    display: inline-block;
    position: relative;
    padding-left: 32px;

    font-family: 'LatoRegular';
    font-size: 12px;
    line-height: 22px;
    color: #1B3858;
    text-align: justify;
    text-shadow: 1px 1px 0px #FFFFFF;

    cursor: pointer;
  }

  input:checked + label:before {	
    content: '';
    display: inline-block;
    position: absolute;
    left: 0px;
    top: 1px;
    background: ${`url(${publicRuntimeConfig.basePath}/icons/V2/checkbox_checked.svg)`} no-repeat center; 
    width: 22px;
    height: 22px; 
    padding: 7px;
  }

  input:not(:checked) + label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 1px;
    width: 22px;
    height: 22px;
    border: 2px solid ${hexToRGBA('#1B3858', 0.5)};
    border-radius: 2px;
    background: #FFFFFF;
  }
`;

const StyledCheck = styled(Form.Check)`
  margin-right: 24px;
`;

function AgreementCheckbox({
  id,
  label = "Label",
}) {
  return (
    <StyledGroup
      controlId={id}
      className="custom-control-invalid"
    >
      <StyledCheck
        inline
        required
        type="checkbox"
        name={id}
        label={label}
      />
    </StyledGroup>
  );
}

export default AgreementCheckbox;
